import type { UseIdpConnectionFlow } from '@hotjar/webapp/domains/sso/hooks/useIdpConnectionFlow';
import { NewConnectionState } from '@hotjar/webapp/domains/sso/hooks/useIdpConnectionFlow';
import type { Organization } from '@hotjar/organization';

import { SelectOrganizationModal } from './modals/SelectOrganizationModal';
import { ConfirmConnectionModal } from './modals/ConfirmConnectionModal';
import { ConnectionSuccessModal } from './modals/ConnectionSuccessModal';

interface Props {
  idpConnectionFlow: UseIdpConnectionFlow;
  organizations: Organization[];
}

export const ConnectOrganizationModals = ({
  idpConnectionFlow,
  organizations,
}: Props): JSX.Element => {
  const {
    newConnectionState,
    isLoading,
    selectedIdp,
    selectedOrganization,
    selectOrganizationForConnection,
    confirmConnection,
    dismissConnection,
    restartConnection,
  } = idpConnectionFlow;

  return (
    <>
      {newConnectionState === NewConnectionState.SELECT_ORGANIZATION && selectedIdp && (
        <SelectOrganizationModal
          isOpen
          onSubmit={selectOrganizationForConnection}
          onCancel={dismissConnection}
          identityProvider={selectedIdp}
          organizations={organizations}
        />
      )}

      {newConnectionState === NewConnectionState.CONFIRM && selectedIdp && selectedOrganization && (
        <ConfirmConnectionModal
          isOpen
          isLoading={isLoading}
          onSubmit={confirmConnection}
          onCancel={dismissConnection}
          organization={selectedOrganization}
        />
      )}

      {newConnectionState === NewConnectionState.SUCCESS && selectedIdp && selectedOrganization && (
        <ConnectionSuccessModal
          isOpen
          onDone={dismissConnection}
          onConnectAnotherOrganization={restartConnection}
          organization={selectedOrganization}
        />
      )}
    </>
  );
};
